import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { DpPaginationModule, DpTableModule, Table } from '@docpath/webcomponents';

import { Alias } from '../../../alias/models/alias';
import { AlertRulesHttpService } from '../../services/alert-rules-http.service';
import { AlertRulesHeaderService } from '../header/alert-rules-header.service';
import { AlertRulesTableService } from './alert-rules-table.service';

@Component({
    selector: 'app-alert-rules-table',
    templateUrl: './alert-rules-table.component.html',
    standalone: true,
    imports: [DpTableModule, DpPaginationModule]
})
export class AlertRulesTableComponent implements OnInit {

    @Input() filters: Filter[] = [];
    @Output() selectedRow = new EventEmitter<void>();
    @Output() tableLoaded = new EventEmitter<Table>();

    table: Table;
    showLoading = false;

    alias: Alias[] = [];

    private readonly alertRulesTableService = inject(AlertRulesTableService);
    private readonly alertRulesHeaderService = inject(AlertRulesHeaderService);
    private readonly alertRulesHttpService = inject(AlertRulesHttpService);

    constructor() {
        this.table = this.alertRulesTableService.initTable();
    }

    ngOnInit(): void {

        this.alertRulesTableService.alertRulesLoaded.subscribe(result => {
            this.table.header = this.alertRulesTableService.initTableHeader();
            this.table.body = this.alertRulesTableService.initTableBody(result, this.alias);
        });

        this.alertRulesHeaderService.aliasOptionsLoaded.subscribe(result => {
            this.alias = result;
        });

        this.alertRulesHttpService.showLoadingChanged.subscribe(showLoading => {
            this.showLoading = showLoading;
        });

        this.alertRulesHeaderService.loadAliasOptions();

        this.alertRulesTableService.loadAlertRules([], 1, 25);

        this.tableLoaded.emit(this.table);

    }
    onChangeCheck(): void {
        this.selectedRow.emit();
    }

    onChangePage(page: number): void {
        this.alertRulesTableService.loadAlertRules(this.filters, page);
    }

    onChangePageSize(size: number): void {
        this.alertRulesTableService.loadAlertRules(this.filters, 1, size);
    }

    getCurrentPage(): number {
        return this.alertRulesTableService.getCurrentPage();
    }

    getCurrentSize(): number {
        return this.alertRulesTableService.getCurrentSize();
    }

    getElements(): number {
        return this.alertRulesTableService.getElements();
    }

}